import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButton,
  IonIcon,
  IonText
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { refreshOutline, logoApple, logoGooglePlaystore } from 'ionicons/icons';
import { PlatformService } from '../../services/platform.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-update-modal',
  templateUrl: './app-update-modal.component.html',
  styleUrls: ['./app-update-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton,
    IonIcon,
    IonText
  ]
})
export class AppUpdateModalComponent implements OnInit {
  @Input() minimumAppVersion: string = '';
  @Input() updateMessage: string = '';

  isNative = false;
  platform: 'ios' | 'android' | 'web' = 'web';
  showMobileAppPromo = false;

  readonly appStoreUrl = environment.appStoreUrl;
  readonly playStoreUrl = environment.playStoreUrl;

  constructor(private platformService: PlatformService) {
    addIcons({ refreshOutline, logoApple, logoGooglePlaystore });
  }

  ngOnInit(): void {
    this.isNative = this.platformService.isNative();
    this.platform = this.platformService.getPlatform();

    // Show mobile app promo if on web but on a mobile device (based on user agent)
    if (!this.isNative) {
      this.showMobileAppPromo = this.isMobileUserAgent();
    }
  }

  /**
   * Refresh the page (for web users)
   */
  onRefresh(): void {
    window.location.reload();
  }

  /**
   * Open App Store (for iOS)
   */
  onOpenAppStore(): void {
    window.open(this.appStoreUrl, '_blank');
  }

  /**
   * Open Play Store (for Android)
   */
  onOpenPlayStore(): void {
    window.open(this.playStoreUrl, '_blank');
  }

  /**
   * Check if the user agent indicates a mobile device
   */
  private isMobileUserAgent(): boolean {
    const ua = navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod|android/.test(ua);
  }

  /**
   * Check if user agent is iOS (for showing appropriate store link)
   */
  get isIosUserAgent(): boolean {
    const ua = navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(ua);
  }
}
